import Vue from 'vue'
import Router from 'vue-router'


import header from '@/components/header'
import login from '@/components/login'

import market from '@/components/market'
import companyResearch from '@/components/companyResearch'
import optional from '@/components/optional'

// 市场画像
import analysis from '@/components/market/analysis'

import Increase from '@/components/market/financial/Increase'
import Expansion from '@/components/market/financial/Expansion'
import ShrinkingCoreInterests from '@/components/market/financial/ShrinkingCoreInterests'
import Goodwill from '@/components/market/financial/Goodwill'
import RevenueAndProfit from '@/components/market/financial/RevenueAndProfit'
import Decline from '@/components/market/financial/Decline'
import Investment from '@/components/market/financial/Investment'
import InvestmentFailure from '@/components/market/financial/InvestmentFailure'
import CreditImpairment from '@/components/market/financial/CreditImpairment'
import ProfitAndCash from '@/components/market/financial/ProfitAndCash'
import RevenueStructure from '@/components/market/financial/RevenueStructure'
import Merger from '@/components/market/financial/Merger'
import TransferSubsidiaries from '@/components/market/financial/TransferSubsidiaries'
import AssetImpairment from '@/components/market/financial/AssetImpairment'
import ProfitStructure from '@/components/market/financial/ProfitStructure'
import HighLeverage from '@/components/market/financial/HighLeverage'
import TransferAssets from '@/components/market/financial/TransferAssets'
import ExtraordinaryItem from '@/components/market/financial/ExtraordinaryItem'

import ShareholderReduction from '@/components/market/corporate/ShareholderReduction'
import ExecutiveReduction from '@/components/market/corporate/ExecutiveReduction'
import ExternalGuarantee from '@/components/market/corporate/ExternalGuarantee'
import PersonnelStructure from '@/components/market/corporate/PersonnelStructure'
import ActualControllerChange from '@/components/market/corporate/ActualControllerChange'
import EquityPledge from '@/components/market/corporate/EquityPledge'
import ExecutiveTurnover from '@/components/market/corporate/ExecutiveTurnover'
import FinancingDividends from '@/components/market/corporate/FinancingDividends'
import AuditOpinion from '@/components/market/corporate/AuditOpinion'
import PersonnelEfficiency from '@/components/market/corporate/PersonnelEfficiency'

import PerformanceForecast from '@/components/market/disclosure/PerformanceForecast'
import PerformanceExpress from '@/components/market/disclosure/PerformanceExpress'
import ToDisclose from '@/components/market/disclosure/ToDisclose'
import Disclosed from '@/components/market/disclosure/Disclosed'

// 公司研究-财报
import researchMain from '@/components/research/researchMain'

import business from '@/components/research/business/business'
import company from '@/components/research/company/company'
import riskMonitor from '@/components/research/risk/riskMonitor'
import industryComparison from '@/components/research/industry/industryComparison'
import financialStatements from '@/components/research/finance/financialStatements'

import companyReport from '@/components/research/companyReport'
import myUser from '@/components/myUser'
import subscriptionPage from '@/components/subscriptionPage'
import induCompare from '@/components/induCompare'
import induCompareBuy from '@/components/induCompareBuy'


Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'header',
    component: header,
    children: [
      {
        path: 'market',
        name: 'market',
        component: market,
        children: [
          {
            path: 'analysis',
            name: 'analysis',
            component: analysis,
          }, {
            path: 'Increase',
            name: 'Increase',
            component: Increase,
          }, {
            path: 'Expansion',
            name: 'Expansion',
            component: Expansion,
          }, {
            path: 'ShrinkingCoreInterests',
            name: 'ShrinkingCoreInterests',
            component: ShrinkingCoreInterests,
          }, {
            path: 'Goodwill',
            name: 'Goodwill',
            component: Goodwill,
          }, {
            path: 'RevenueAndProfit',
            name: 'RevenueAndProfit',
            component: RevenueAndProfit,
          }, {
            path: 'Decline',
            name: 'Decline',
            component: Decline,
          }, {
            path: 'Investment',
            name: 'Investment',
            component: Investment,
          }, {
            path: 'InvestmentFailure',
            name: 'InvestmentFailure',
            component: InvestmentFailure,
          }, {
            path: 'CreditImpairment',
            name: 'CreditImpairment',
            component: CreditImpairment,
          }, {
            path: 'ProfitAndCash',
            name: 'ProfitAndCash',
            component: ProfitAndCash,
          }, {
            path: 'RevenueStructure',
            name: 'RevenueStructure',
            component: RevenueStructure,
          }, {
            path: 'Merger',
            name: 'Merger',
            component: Merger,
          }, {
            path: 'TransferSubsidiaries',
            name: 'TransferSubsidiaries',
            component: TransferSubsidiaries,
          }, {
            path: 'AssetImpairment',
            name: 'AssetImpairment',
            component: AssetImpairment,
          }, {
            path: 'ProfitStructure',
            name: 'ProfitStructure',
            component: ProfitStructure,
          }, {
            path: 'HighLeverage',
            name: 'HighLeverage',
            component: HighLeverage,
          }, {
            path: 'TransferAssets',
            name: 'TransferAssets',
            component: TransferAssets,
          }, {
            path: 'ExtraordinaryItem',
            name: 'ExtraordinaryItem',
            component: ExtraordinaryItem,
          },

          {
            path: 'ShareholderReduction',
            name: 'ShareholderReduction',
            component: ShareholderReduction,
          }, {
            path: 'ExecutiveReduction',
            name: 'ExecutiveReduction',
            component: ExecutiveReduction,
          }, {
            path: 'ExternalGuarantee',
            name: 'ExternalGuarantee',
            component: ExternalGuarantee,
          }, {
            path: 'PersonnelStructure',
            name: 'PersonnelStructure',
            component: PersonnelStructure,
          }, {
            path: 'ActualControllerChange',
            name: 'ActualControllerChange',
            component: ActualControllerChange,
          }, {
            path: 'EquityPledge',
            name: 'EquityPledge',
            component: EquityPledge,
          }, {
            path: 'ExecutiveTurnover',
            name: 'ExecutiveTurnover',
            component: ExecutiveTurnover,
          }, {
            path: 'FinancingDividends',
            name: 'FinancingDividends',
            component: FinancingDividends,
          }, {
            path: 'AuditOpinion',
            name: 'AuditOpinion',
            component: AuditOpinion,
          }, {
            path: 'PersonnelEfficiency',
            name: 'PersonnelEfficiency',
            component: PersonnelEfficiency,
          },

          {
            path: 'PerformanceForecast',
            name: 'PerformanceForecast',
            component: PerformanceForecast,
          }, {
            path: 'PerformanceExpress',
            name: 'PerformanceExpress',
            component: PerformanceExpress,
          }, {
            path: 'ToDisclose',
            name: 'ToDisclose',
            component: ToDisclose,
          }, {
            path: 'Disclosed',
            name: 'Disclosed',
            component: Disclosed,
          }
        ]
      },{
        path: 'companyResearch',
        name: 'companyResearch',
        component: companyResearch,
      },{
        path: 'optional',
        name: 'optional',
        component: optional,
      },{
        path: 'researchMain',
        name: 'researchMain',
        component: researchMain,
        children: [
          {
            path: 'business',
            name: 'business',
            component: business,
          }, {
            path: 'company',
            name: 'company',
            component: company,
          }, {
            path: 'riskMonitor',
            name: 'riskMonitor',
            component: riskMonitor,
          }, {
            path: 'industryComparison',
            name: 'industryComparison',
            component: industryComparison,
          }, {
            path: 'financialStatements',
            name: 'financialStatements',
            component: financialStatements,
          }
        ]
      },{
        path: 'companyReport',
        name: 'companyReport',
        component: companyReport,
      },{
        path: 'myUser',
        name: 'myUser',
        component: myUser,
      },{
        path: 'subscriptionPage',
        name: 'subscriptionPage',
        component: subscriptionPage,
      },{
        path: 'induCompare',
        name: 'induCompare',
        component: induCompare,
      },{
        path: 'induCompareBuy',
        name: 'induCompareBuy',
        component: induCompareBuy,
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: login,
  }
]


const router = new Router({
  // mode: 'history',
  // base: '/apply/',
  mode: 'hash',
  routes
})


export default router
